import DServiceProviderPage from './DServiceProviderPage'

export default DServiceProviderPage
